import { useState } from 'react';
import BrokerStatus from './components/BrokerStatus';
import BrokerSelect from './components/BrokerSelect';
import HeadersAuth from '../../components/base/HeadersAuth';

export default function BrokerConnectPage() {
  const [isConnected, setIsConnected] = useState(false);

  // ฟังก์ชันที่ใช้เพื่อให้สถานะการเชื่อมต่อเปลี่ยนเป็น true เมื่อเชื่อมต่อโบรกเกอร์สำเร็จ
  const handleConnectionStatusChange = (status) => {
    setIsConnected(status);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-purple-800 to-black text-white">
      <HeadersAuth />
      <div className="pt-[80px] min-h-screen flex items-center justify-center">
        <div className="bg-zinc-900 text-white p-8 rounded-xl shadow-xl w-full max-w-md">
          <h2 className="text-2xl font-semibold text-purple-300 mb-4">Broker Integration</h2>

          {/* แสดงสถานะการเชื่อมต่อ */}
          <BrokerStatus isConnected={isConnected} />

          {/* ส่งฟังก์ชันการอัปเดตสถานะไปยัง BrokerSelect */}
          <BrokerSelect onConnectionStatusChange={handleConnectionStatusChange} />
        </div>
      </div>

    </div>
  );
}

